/*
Copyright (c) 2024, HP Development Company, L.P. All rights reserved.
This software contains confidential and proprietary information of HP.
The user of this software agrees not to disclose, disseminate or copy
such Confidential Information and shall use the software only in accordance
with the terms of the license agreement the user entered into with HP.
*/

import React, { memo } from 'react';
import { SectionListHeaderProps } from './types';
import './styles.scss';
import { generateID } from '../../base/helper';

const Header: React.FC<SectionListHeaderProps> = ({
  title,
  tooltip,
  end,
  borderBottom = true,
  id = generateID('clientos-ui-toolkit-section-list-container-header')
}) => {
  return (
    <>
      <div
        className="clientos-ui-toolkit-section-list-container__content__header"
        id={id}
      >
        <div
          className="clientos-ui-toolkit-section-list-container__content__header__start"
          id={`${id}__start`}
        >
          <div
            className="clientos-ui-toolkit-section-list-container__content__header__title subtitle-regular--medium "
            id={`${id}__title`}
            aria-label={title}
            role="text"
          >
            {title}
          </div>
          {tooltip && (
            <div
              className="clientos-ui-toolkit-section-list-container__content__header__tooltip"
              id={`${id}__tooltip`}
            >
              {tooltip}
            </div>
          )}
        </div>
        {end && (
          <div
            className="clientos-ui-toolkit-section-list-container__content__header__end"
            id={`${id}__end`}
          >
            {end}
          </div>
        )}
      </div>
      {borderBottom && (
        <div className="clientos-ui-toolkit-section-list-container__item__separator" />
      )}
    </>
  );
};

export default memo(Header);
